/**
 * Размеры записи ленты, общие у живого превью и скелетона. Лежат в лёгком файле, чтобы скелетон
 * не тянул за собой зависимости компонента (`TeamLogo`).
 */

/** Диаметр эмблемы в превью, px. */
export const MATCH_PREVIEW_LOGO_SIZE = 36;

/**
 * Серая плашка превью: высота 64 (как у фото в новостной ленте), ширина — по содержимому, отступ с боков
 * тот же, что сверху. Классы общие со скелетоном: плашка загрузки обязана совпасть с живой по размеру.
 */
export const MATCH_PREVIEW_PLATE_CLASS =
  'bg-surfaceSunken rounded-card flex h-16 shrink-0 items-start justify-center gap-1 px-1.5 pt-1.5';
